export default __webpack_public_path__ + "static/media/train-1.f53ced25.png";